export const checkLinkPath = (link: string) => {
  const isExternalPage = link.startsWith("http") || link.startsWith("https");
  const startWithBar = link.startsWith("/");

  const shouldIncludeBarToInternalPage = !isExternalPage && !startWithBar;

  if (shouldIncludeBarToInternalPage) return "/".concat(link);
  else return link;
};
